import React from 'react'
import { useTranslation } from 'react-i18next'

import ChecklistTypesSelect from '../../../../../containers/checklistTypes/select/ChecklistTypesSelect'
import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import FormItem from '../../../../../components/form/FormItem'
import SectionsSeparator from './SectionsSeparator'

const NameAndTypeSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  return (
    <>
      <FlexGrid paddingGutter={0.5} align="flex-start" justify="flex-start" wrap>
        <FlexCol width="70%">
          <FormItem label={t('fieldsStep.name')} field="name" {...commonProps} />
        </FlexCol>
        <FlexCol width="30%">
          <FormItem label={t('fieldsStep.type')} field="type" {...commonProps}>
            <ChecklistTypesSelect
              selectedLabel={form.type.name}
              value={form.type.id}
              onChange={(value, label, { origin }) => handleChange('type', origin)}
            />
          </FormItem>
        </FlexCol>
      </FlexGrid>
      <SectionsSeparator />
    </>
  )
}

export default NameAndTypeSection
